const RAW_REGION_PAGES = [
  {
    slug: "transport-normandie",
    h1: "Transport en Normandie",
    metaTitle: "Transport en Normandie — Express Delivery",
    metaDescription: "Express Delivery organise vos transports dans toute la Normandie : meubles, électroménager, déménagements et longue distance.",
    intro: "Basé au Havre, Express Delivery intervient dans toute la Normandie : Seine-Maritime, Eure, Calvados, Manche et Orne. Meubles, électroménager, déménagements et transports longue distance.",
  },
  {
    slug: "transport-longue-distance-normandie",
    h1: "Transport longue distance depuis la Normandie",
    metaTitle: "Transport longue distance Normandie — Express Delivery",
    metaDescription: "Transport longue distance depuis la Normandie vers d'autres régions françaises, avec groupage possible selon disponibilité.",
    intro: "Depuis la Normandie, Express Delivery organise des transports longue distance vers d'autres régions françaises, avec optimisation du trajet à l'aller comme au retour lorsque cela est possible.",
  },
  {
    slug: "groupage-transport-normandie",
    h1: "Groupage transport en Normandie",
    metaTitle: "Groupage transport Normandie — Express Delivery",
    metaDescription: "Le groupage permet d'optimiser les trajets en Normandie et de proposer un tarif plus avantageux selon les disponibilités.",
    intro: "En Normandie, Express Delivery propose des solutions de groupage pour optimiser les trajets et proposer un tarif plus avantageux lorsque plusieurs transports sont compatibles.",
  },
  {
    slug: "transport-normandie-ile-de-france",
    h1: "Transport Normandie ↔ Île-de-France",
    metaTitle: "Transport Normandie Île-de-France — Express Delivery",
    metaDescription: "Transport entre la Normandie et l'Île-de-France pour meubles, électroménager et déménagements, groupage possible.",
    intro: "Express Delivery organise des transports entre la Normandie et l'Île-de-France : meubles, électroménager, achats entre particuliers et déménagements, avec groupage possible selon disponibilité.",
  },
  {
    slug: "transport-normandie-bretagne",
    h1: "Transport Normandie ↔ Bretagne",
    metaTitle: "Transport Normandie Bretagne — Express Delivery",
    metaDescription: "Transport entre la Normandie et la Bretagne pour meubles, électroménager et déménagements, groupage possible.",
    intro: "Express Delivery organise des transports entre la Normandie et la Bretagne : meubles, électroménager, achats entre particuliers et déménagements, avec groupage possible selon disponibilité.",
  },
  {
    slug: "transport-normandie-hauts-de-france",
    h1: "Transport Normandie ↔ Hauts-de-France",
    metaTitle: "Transport Normandie Hauts-de-France — Express Delivery",
    metaDescription: "Transport entre la Normandie et les Hauts-de-France pour meubles, électroménager et déménagements, groupage possible.",
    intro: "Express Delivery organise des transports entre la Normandie et les Hauts-de-France : meubles, électroménager, achats entre particuliers et déménagements, avec groupage possible selon disponibilité.",
  },
];

// Toutes les pages régionales sont phase 1 : ce sont des pages de cocon SEO larges,
// déjà qualitatives et directement utiles (pas de contenu "fin").
export const REGION_PAGES = RAW_REGION_PAGES.map((r) => ({ ...r, isPhase1: true }));

export function getRegionPageBySlug(slug) {
  return REGION_PAGES.find((r) => r.slug === slug);
}
